import Featured from './Featured.svelte';
import Searchbar from './Searchbar.svelte';
import './assets/global.css';
import ListingRedirect from "./ListingRedirect.svelte";

console.log('--------------------------------');
console.log('bizzer plugin loaded');
let foundElements = false;
const featuredElement = document.getElementById('bizzer-featured');
if (featuredElement) {
    new Featured({
        target: featuredElement,
    });
    foundElements = true;
} else {
    console.warn("Element with id 'bizzer-featured' not found.");
}

const allListingsElement = document.getElementById('bizzer-all-listings');
if (allListingsElement) {
    new ListingRedirect({
        target: allListingsElement,
    });
    foundElements = true;
} else {
    console.warn("BIZZER: Element with id 'bizzer-all-listings' not found.");
}

const searchbarElement = document.getElementById('bizzer-searchbar');
if (searchbarElement) {
    new Searchbar({
        target: searchbarElement,
    });
    foundElements = true;
} else {
    console.warn("BIZZER: Element with id 'bizzer-searchbar' not found.");
}

if (!foundElements) {
    console.warn("BIZZER: No elements found.");
}
console.log('--------------------------------');
